import cs from 'classnames';
import React from 'react';
import { useAppContext } from '../../app/AppContext';
import { ProtectionPlan_ApplicationFragment, useUpdateProtectionPlanMutation } from '../../generated.graphql';
import { useElementId } from 'shared/utils/elementIds';


interface Props {
  application: ProtectionPlan_ApplicationFragment
  className?: string
}

interface CheckboxProps extends Props {
  children?: React.ReactNode
  mode: 'checkbox' | 'switch'
}


export const ProtectionPlanCheckbox = (props: CheckboxProps) => {
  const elementId = useElementId('ProtectionPlan');
  const [result, mutate] = useUpdateProtectionPlanMutation();
  const app = useAppContext();

  return (
    <div className={cs(`custom-control custom-${props.mode}`, props.className)}>
      <input 
        type="checkbox" 
        className="custom-control-input" 
        id={elementId} 
        disabled={result.fetching}
        checked={props.application.includesProtectionPlan} 
        onChange={e => mutate({portalSlug: app.portalSlug, input: {protectionPlan: e.target.checked}})}
      />
      <label className="custom-control-label" htmlFor={elementId}>{props.children}</label>
    </div>
  )
}


export const ProtectionPlanLabelledCheckbox = (props: Props) => {
  const elementId = useElementId('ProtectionPlan');
  const [result, mutate] = useUpdateProtectionPlanMutation();
  const app = useAppContext();

  return (
    <ProtectionPlanCheckbox {...props} mode="checkbox">
      Yes, I'd like the Protection Plan to apply on the selected products 
      for an extra ${Math.round(props.application.pricing.protectionPlan)}/month.
    </ProtectionPlanCheckbox>
  )
}
